"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBasicAccessPermissionType = exports.getBasicAccessPermissionType = exports.INTERACTION_TYPE_PERMISSION = void 0;
exports.INTERACTION_TYPE_PERMISSION = "permission";
function getBasicAccessPermissionType() {
    return "basic-access";
}
exports.getBasicAccessPermissionType = getBasicAccessPermissionType;
function isBasicAccessPermissionType(type) {
    return type === getBasicAccessPermissionType();
}
exports.isBasicAccessPermissionType = isBasicAccessPermissionType;
//# sourceMappingURL=types.js.map